import { useNavigate } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import ConnectGuide from '@/components/ConnectGuide';
import HeroSection from '@/components/sections/HeroSection';
import WhatIsConnect from '@/components/sections/WhatIsConnect';
import ProductShowcase from '@/components/sections/ProductShowcase';
import WhoItsFor from '@/components/sections/WhoItsFor';
import ThreePillars from '@/components/sections/ThreePillars';
import PlansSection from '@/components/sections/PlansSection';
import FamilyWellness from '@/components/sections/FamilyWellness';
import WhatToMonitor from '@/components/sections/WhatToMonitor';
import FeaturesGrid from '@/components/sections/FeaturesGrid';
import PetCareSection from '@/components/sections/PetCareSection';
import FAQSection from '@/components/sections/FAQSection';
import PrivacySection from '@/components/sections/PrivacySection';
import FinalCTA from '@/components/sections/FinalCTA';

const LandingPage = () => {
  const navigate = useNavigate();
  const goToReserve = () => navigate('/reserve');

  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Navigation />
      
      <main>
        <HeroSection onReserveClick={goToReserve} />
        
        <WhatIsConnect />
        
        <div className="section-divider" />
        
        <ProductShowcase />
        
        <div className="section-divider" />
        
        <WhoItsFor />
        
        <div className="section-divider" />
        
        <ThreePillars />
        
        <div className="section-divider" />
        
        <PlansSection onReserveClick={goToReserve} />
        
        <PetCareSection onReserveClick={goToReserve} />
        
        <div className="section-divider" />
        
        <FamilyWellness />
        
        <div className="section-divider" />
        
        <WhatToMonitor />
        
        <div className="section-divider" />
        
        <FeaturesGrid />
        
        <div className="section-divider" />
        
        <FAQSection />
        
        <div className="section-divider" />
        
        <PrivacySection />
        
        <FinalCTA onReserveClick={goToReserve} />
      </main>

      <Footer />
      
      {/* Premium AI Chatbot */}
      <ConnectGuide />
    </div>
  );
};

export default LandingPage;
